import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function Hero() {
  return <section className="py-16 md:py-24 text-center" data-id="element-116">
      <div className="container mx-auto px-4" data-id="element-117">
        <div className="mb-8" data-id="element-118">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZt8Y24BXXUUFMEFqS2eFe/sport-pro-04-min_2.png" alt="SportProZ Logo" className="mx-auto w-64 md:w-80 h-auto" data-id="element-119" />
        </div>
        <h1 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-120">
          <span className="text-black" data-id="element-121">Reveal Yourself</span>
          <br data-id="element-122" />
          <span className="text-blue-500" data-id="element-123">Build Your Network</span>
          <br data-id="element-124" />
          <span className="text-black" data-id="element-125">Coming Soon</span>
        </h1>
        <p className="text-gray-700 max-w-2xl mx-auto mb-8 text-lg" data-id="element-126">
          Connect with teams, players, sponsors, journalists and scouts on the
          ultimate sports social network. Showcase your talent, discover
          opportunities, and build meaningful connections in the sports world.
        </p>
        <div className="mb-12" data-id="element-127">
          <h3 className="text-xl font-semibold mb-6" data-id="element-128">App Launch Countdown</h3>
          <CountdownTimer data-id="element-129" />
        </div>
        <div className="mt-8 flex justify-center" data-id="element-130">
          <a href="#features" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-131">
            Learn More
          </a>
        </div>
      </div>
    </section>;
}